import React,{useContext} from 'react'
import GlobalContext from '../../../../context/GlobalContext'
import './CalenderHeader.css'
import arrow from '../../../../images/admin/arrow.png'
import dayjs from 'dayjs'


const CalenderHeader = ({data}) =>{
  const {monthIndex,setMonthIndex} = useContext(GlobalContext)
  function handlePrevMonth(){
    setMonthIndex(monthIndex - 1)
  }

  function handleNextMonth(){
    setMonthIndex(monthIndex + 1)
  }
  function handleReset(){
    setMonthIndex(monthIndex === dayjs().month() ? monthIndex + Math.random() : dayjs().month())
  }
  return(
    <div className="CalenderHeader__wrapper">
      <img src={data.logo} alt="logo" className=" CalenderHeader__logo"/>
      <h1 className="CalenderHeader__heading">{data.title} Calendar</h1>
      <button className="CalenderHeader__button" onClick={handleReset}>Today</button>
      <button className="CalenderHeader__button2" onClick={handlePrevMonth}>
        <span><img className="CalenderHeader__img2" src={arrow}/></span>
      </button>
      <button className="CalenderHeader__button3" onClick={handleNextMonth}>
        <span><img className="CalenderHeader__img3" src={arrow}/></span>
      </button>
      <h2 className="CalenderHeader__h2">{dayjs(new Date(dayjs().year(),monthIndex)).format("MMMM YYYY")}</h2>
    </div>
  )
}
export default CalenderHeader
